<div #container ngDraggable [handle]="dragHandle" class="container flex column">
  <div #dragHandle class="flex row space-between header">
    <div class="flex column justify-center">
      <h2>{{ vm.selectedJob.name }} - Report</h2>
    </div>
    <div class="flex row justify-center window-buttons">
      <evrideo-x-button
        (mousedown)="vm.closeReport()"
        [overrideStyle]="{
          'margin-top': '-0.11vw',
          width: '1.15vw',
          height: '1.15vw'
        }"
      ></evrideo-x-button>
    </div>
  </div>
  <div class="flex column body">
    <ng-container *ngIf="!vm.selectedReport">
      <div class="report-loading flex row fill-height justify-center">
        <p class="report-loading-message">{{ loadingMessage }}</p>
      </div>
    </ng-container>

    <ng-container *ngIf="vm.selectedReport">
      <table class="report-table">
        <thead>
          <tr>
            <th>Video ID</th>
            <th>Date And Time</th>
            <th>Delivery Status</th>
            <th>Download</th>
            <th>Import</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let reportEntry of vm.selectedReport">
            <td>
              <a href="/mam/editMedia/{{ reportEntry.mediaId }}">{{
                reportEntry.tenantUniqueId
              }}</a>
            </td>
            <td>{{ reportEntry.dateTime }}</td>
            <td>{{ reportEntry.deliveryStatus | humanize }}</td>
            <td>
              <a
                *ngIf="
                  reportEntry.deliveryStatus === 'Finished' ||
                  reportEntry.deliveryStatus === 'DeliveredToDestinations'
                "
                href="{{ reportEntry.downloadUrl }}"
                target="_blank"
                download="{{
                  reportEntry.tenantUniqueId
                    ? reportEntry.tenantUniqueId
                    : reportEntry.mediaId
                }}"
                >Download</a
              >
            </td>
            <td>
              <a (click)="vm.uploadToMAM(reportEntry); $event.preventDefault()"  href="#">Import To MAM</a>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </div>
</div>
